var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardLogo = function SvgCardLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 99 14"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "card-logo_svg__a",
    width: 99,
    height: 14,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.208.137h98.584V14H.208z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#card-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "card-logo_svg__c",
    width: 97,
    height: 12,
    x: 1,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#121214",
    clipPath: "url(#card-logo_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.772 1.9H6.75c1.302 0 2.33.322 3.095.968s1.153 1.569 1.153 2.782-.388 2.137-1.153 2.782c-.766.657-1.805.98-3.095.98H4.969v3.015H1.772zM6.146 6.94c.49 0 .879-.1 1.153-.29s.422-.522.422-1.012-.137-.801-.422-.99c-.274-.19-.662-.29-1.153-.29H4.969v2.57h1.177zM11.766 1.9h3.198v3.873h3.597V1.9h3.198v10.528H18.56v-4.04h-3.597v4.04h-3.198zM25.56 11.96a5.2 5.2 0 0 1-2.102-1.936c-.514-.824-.765-1.781-.765-2.85 0-1.068.251-2.025.765-2.86a5.3 5.3 0 0 1 2.101-1.947c.891-.456 1.884-.69 2.98-.69s2.08.234 2.959.69a5.35 5.35 0 0 1 2.09 1.948c.513.834.765 1.791.765 2.86s-.252 2.025-.766 2.849a5.4 5.4 0 0 1-2.09 1.936c-.879.467-1.872.69-2.957.69a6.5 6.5 0 0 1-2.98-.69m4.27-2.537c.389-.2.697-.501.914-.89.228-.39.343-.846.343-1.358 0-.768-.24-1.391-.731-1.848-.48-.467-1.097-.69-1.828-.69-.73 0-1.358.234-1.85.69-.49.457-.73 1.08-.73 1.848 0 .523.114.979.342 1.357.229.39.537.68.925.89.388.212.834.312 1.313.312.48 0 .903-.1 1.29-.311zM37.4 4.526h-2.901V1.9h9.01v2.615h-2.9v7.901H37.41v-7.89zM46.222 11.96a5.2 5.2 0 0 1-2.101-1.936c-.514-.824-.765-1.781-.765-2.85 0-1.068.251-2.025.765-2.86a5.3 5.3 0 0 1 2.101-1.947c.89-.456 1.884-.69 2.97-.69 1.084 0 2.078.234 2.957.69a5.35 5.35 0 0 1 2.09 1.948c.514.834.765 1.791.765 2.86s-.251 2.025-.765 2.849a5.4 5.4 0 0 1-2.09 1.936c-.88.467-1.873.69-2.958.69s-2.078-.234-2.969-.69m4.271-2.537c.388-.2.697-.501.914-.89.228-.39.342-.846.342-1.358 0-.768-.24-1.391-.73-1.848-.48-.467-1.097-.69-1.828-.69-.73 0-1.359.234-1.85.69-.49.457-.73 1.08-.73 1.848 0 .523.114.979.342 1.357.228.39.537.68.925.89.388.212.834.312 1.313.312.48 0 .902-.1 1.29-.311zM58.507 11.993c-.891-.445-1.588-1.08-2.067-1.892-.48-.823-.731-1.791-.731-2.926s.24-2.104.73-2.927c.48-.824 1.177-1.458 2.068-1.903.89-.445 1.941-.668 3.14-.668q2.415 0 3.769.868v2.871a4.6 4.6 0 0 0-1.53-.723c-.572-.156-1.223-.223-1.965-.223-.97 0-1.701.234-2.204.713-.502.467-.754 1.135-.754 1.992s.24 1.569.72 2.025 1.176.69 2.078.69c.446 0 .8-.056 1.085-.178V8.377h-1.484v-1.97h4.408v5.275c-1.097.668-2.467.99-4.123.99-1.199 0-2.238-.222-3.14-.667zM67.003 1.9h5.025c1.301 0 2.318.322 3.072.957.753.634 1.13 1.558 1.13 2.76 0 .779-.171 1.446-.502 2.003-.331.556-.811.98-1.428 1.269l1.805 3.539h-3.278l-1.576-3.083h-1.05v3.082h-3.198zm4.385 4.974c.491 0 .88-.089 1.154-.278q.41-.284.41-.968c0-.456-.136-.79-.41-.968-.275-.19-.663-.279-1.154-.279h-1.187v2.504h1.187zM80.477 1.9h3.072l4.317 10.528h-3.278l-.8-2.004h-3.54l-.822 2.004H76.15zm2.57 6.154-1.04-2.95-1.039 2.95h2.0780000000000003M89.945 8.421 86.005 1.9h3.414l2.136 3.628L93.827 1.9h3.404L93.154 8.42v4.007h-3.198V8.42z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#card-logo_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#card-logo_svg__d)",
    d: "M-7.212-1.316h113.761v17.962H-7.212z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "card-logo_svg__d",
    x1: 6.534,
    x2: 10.721,
    y1: 0.929,
    y2: 30.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#505256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#212124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#5D6064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9599A0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "card-logo_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.772 1.677H97.23V12.65H1.77z"
  })))));
};
export default SvgCardLogo;